/**
 * 权限工具函数
 * 用于前端权限检查
 */

/**
 * 更新当前用户的权限数据
 * @param {string[]} permissions - 新的权限码数组
 * @param {string[]} roles - 新的角色名数组
 */
export function updateUserData(permissions, roles) {
  const user = JSON.parse(localStorage.getItem('admin_user') || '{}')
  user.permissions = permissions
  user.roles = roles
  localStorage.setItem('admin_user', JSON.stringify(user))
  // 触发权限更新事件，让指令重新检查
  window.dispatchEvent(new CustomEvent('permissions-updated'))
}

/**
 * 获取当前用户的权限列表
 * @returns {string[]} 权限码数组
 */
export function getPermissions() {
  const user = JSON.parse(localStorage.getItem('admin_user') || '{}')
  return user.permissions || []
}

/**
 * 获取当前用户的角色列表
 * @returns {string[]} 角色名数组
 */
export function getRoles() {
  const user = JSON.parse(localStorage.getItem('admin_user') || '{}')
  return user.roles || []
}

/**
 * 获取当前用户的角色（主角色）
 * @returns {string} 角色名
 */
export function getRole() {
  const user = JSON.parse(localStorage.getItem('admin_user') || '{}')
  return user.role || ''
}

/**
 * 检查是否有指定权限
 * @param {string} permission - 权限码
 * @returns {boolean}
 */
export function hasPermission(permission) {
  const user = JSON.parse(localStorage.getItem('admin_user') || '{}')
  // 超级管理员直接放行
  if (user.role === 'super' || (user.roles && user.roles.includes('super_admin'))) {
    return true
  }
  const permissions = user.permissions || []
  return permissions.includes(permission)
}

/**
 * 检查是否有多个权限（任一即可）
 * @param {string[]} permissions - 权限码数组
 * @returns {boolean}
 */
export function hasAnyPermission(permissions) {
  if (!Array.isArray(permissions)) {
    return hasPermission(permissions)
  }
  const user = JSON.parse(localStorage.getItem('admin_user') || '{}')
  if (user.role === 'super' || (user.roles && user.roles.includes('super_admin'))) {
    return true
  }
  const userPermissions = user.permissions || []
  return permissions.some(p => userPermissions.includes(p))
}

/**
 * 检查是否有所有权限
 * @param {string[]} permissions - 权限码数组
 * @returns {boolean}
 */
export function hasAllPermissions(permissions) {
  if (!Array.isArray(permissions)) {
    return hasPermission(permissions)
  }
  const user = JSON.parse(localStorage.getItem('admin_user') || '{}')
  if (user.role === 'super' || (user.roles && user.roles.includes('super_admin'))) {
    return true
  }
  const userPermissions = user.permissions || []
  return permissions.every(p => userPermissions.includes(p))
}

/**
 * 检查是否有指定角色
 * @param {string} role - 角色名
 * @returns {boolean}
 */
export function hasRole(role) {
  const user = JSON.parse(localStorage.getItem('admin_user') || '{}')
  if (user.role === 'super') {
    return true
  }
  const roles = user.roles || [user.role].filter(Boolean)
  return roles.includes(role)
}

/**
 * 检查是否有多个角色（任一即可）
 * @param {string[]} roles - 角色名数组
 * @returns {boolean}
 */
export function hasAnyRole(roles) {
  if (!Array.isArray(roles)) {
    return hasRole(roles)
  }
  const user = JSON.parse(localStorage.getItem('admin_user') || '{}')
  if (user.role === 'super') {
    return true
  }
  const userRoles = user.roles || [user.role].filter(Boolean)
  return roles.some(r => userRoles.includes(r))
}
